import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {BruteForce} from "../BruteForce";
import {SimplePresentation, SimplePresentationRunner} from "../../core/winpresentation/SimplePresentationRunner";
import {BruteForceBonusIntroPresentation} from "../presentationRunners/BruteForceBonusIntroPresentation";
import {BruteForceGameMode} from "../server/BruteForceGameMode";


export class BruteForceZeroBetIdlePresentation implements FlowStatePresentation {
    private _flowStateController: FlowStateController;
    private readonly _presentations: SimplePresentation[];

    constructor() {
        this._presentations = [
            new BruteForceBonusIntroPresentation(),
        ]
    }

    start(flowStateController: FlowStateController): void {
        this._flowStateController = flowStateController;
        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }

    public complete() {
        if (BruteForce.gameContainer.isTotalNudgeTextVisible && BruteForce.model.nextMode === BruteForceGameMode.FREESPIN_SUPER) {
            let stickyNudgeValue: number = 0;
            BruteForce.model.xNudgeSticky.forEach((item: boolean, index: number) => {
                if (item) {
                    stickyNudgeValue += BruteForce.model.xNudgeMultipliers[index];
                }
            });
            BruteForce.gameContainer.fadeNudgeMultiplier(stickyNudgeValue, 0.6);
        }
        BruteForce.apiPlugin.betHandler.zeroBet();
        BruteForce.keypadPlugin.setZeroBetSpinCounter(BruteForce.model.data.freespinsLeft - 1);
        this._flowStateController.finish();
    }

}